import { publish } from '@wh/message-bus';
export const handleOnButtonClick = (messageBusTopic, messageBusValue) => {
    publish(messageBusTopic, messageBusValue);
};
